import { RISQ_STATUSES, type RisqStatus } from '@opti-sea/risq';

const statuses = new Set<string>(RISQ_STATUSES);

export function isRisqStatus(value: unknown): value is RisqStatus {
  return typeof value === 'string' && statuses.has(value);
}
